import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface CourseDetailsFormState {
	formData: Record<string, unknown>;
	currentStep: number;
	currentSubStep: number;
	maxReachedStep: number;
	maxReachedSubStep: number;
	lastSaved: string | null;
	isDirty: boolean;
}

const initialState: CourseDetailsFormState = {
	formData: {},
	currentStep: 0,
	currentSubStep: 0,
	maxReachedStep: 0,
	maxReachedSubStep: 0,
	lastSaved: null,
	isDirty: false,
};

const courseDetailsFormSlice = createSlice({
	name: "courseDetailsForm",
	initialState,
	reducers: {
		setFormData: (state, action: PayloadAction<Record<string, unknown>>) => {
			state.formData = action.payload;
			state.isDirty = true;
		},
		setCurrentStep: (state, action: PayloadAction<number>) => {
			state.currentStep = action.payload;
			if (action.payload > state.maxReachedStep) {
				state.maxReachedStep = action.payload;
			}
		},
		setCurrentSubStep: (state, action: PayloadAction<number>) => {
			state.currentSubStep = action.payload;
			if (action.payload > state.maxReachedSubStep) {
				state.maxReachedSubStep = action.payload;
			}
		},
		setLastSaved: (state, action: PayloadAction<string>) => {
			state.lastSaved = action.payload;
			state.isDirty = false;
		},
		clearFormData: state => {
			state.formData = {};
			state.currentStep = 0;
			state.currentSubStep = 0;
			state.maxReachedStep = 0;
			state.maxReachedSubStep = 0;
			state.lastSaved = null;
			state.isDirty = false;
		},
		updateFormData: (state, action: PayloadAction<Record<string, unknown>>) => {
			state.formData = { ...state.formData, ...action.payload };
			state.isDirty = true;
		},
	},
});

export const { setFormData, setCurrentStep, setCurrentSubStep, setLastSaved, clearFormData, updateFormData } =
	courseDetailsFormSlice.actions;

export default courseDetailsFormSlice.reducer;
